if (!customElements.get('avis-verifies-widget')) {
  class AvisVerifiesWidget extends HTMLElement {
    connectedCallback() {
      const widgetId = this.dataset.widgetId;
      const scriptUrl = this.dataset.widgetScript;
      const mount = this.querySelector('[data-avis-verifies-mount]');
      if (!widgetId || !scriptUrl || !mount) return;

      window.__avisVerifiesHosts = window.__avisVerifiesHosts || {};
      const hosts = window.__avisVerifiesHosts;

      if (!hosts[widgetId]) {
        hosts[widgetId] = { primary: mount, clones: [] };
        mount.id = widgetId;
        this.loadScript(widgetId, scriptUrl);
        this.observe(widgetId, mount);
        return;
      }

      hosts[widgetId].clones.push(mount);
      if (hosts[widgetId].primary.innerHTML) {
        mount.innerHTML = hosts[widgetId].primary.innerHTML;
      }
    }

    loadScript(widgetId, scriptUrl) {
      if (document.querySelector('script[data-avis-verifies="' + widgetId + '"]')) return;

      const script = document.createElement('script');
      script.src = scriptUrl;
      script.defer = true;
      script.charset = 'utf-8';
      script.dataset.avisVerifies = widgetId;
      document.body.appendChild(script);
    }

    observe(widgetId, primary) {
      const observer = new MutationObserver(function () {
        const hosts = window.__avisVerifiesHosts && window.__avisVerifiesHosts[widgetId];
        if (!hosts) return;
        hosts.clones.forEach(function (clone) {
          if (clone.innerHTML !== primary.innerHTML) clone.innerHTML = primary.innerHTML;
        });
      });
      observer.observe(primary, { childList: true, subtree: true });
    }
  }

  customElements.define('avis-verifies-widget', AvisVerifiesWidget);
}
